import { render, staticRenderFns } from "./KnInventoryMovementTypes.vue?vue&type=template&id=58bdb70c&"
import script from "./KnInventoryMovementTypes.vue?vue&type=script&lang=js&"
export * from "./KnInventoryMovementTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports